import { request } from '@/utils/request'
import API from '@/constants/apis'
import * as types from './mutation-types'
import AppError from '@/utils/errors'

export const seatInit = ({
  commit, state
}, { sessionId }) => {
  return request(API.SEAT_INIT_API(sessionId), 'GET').then(res => {
    commit(types.SEAT_INIT, res)
    const selectedSeats = res.seats.filter(seat => seat.selected === 2)
    commit(types.UPDATE_SELECTED_SEATS, selectedSeats)
    return res
  })
}

export const selectSeat = ({
  commit
}, { seatId, sessionId, selected }) => {
  return request(API.SEAT_SELECT_API, 'POST', { sessionId, seatId }).then(res => {
    if (!res.success) {
      throw new AppError(res.msg || '系统错误，请稍后重试')
    }
    if (selected === 0) {
      return true
    }
    if (selected === 2 && res.selected === 2) {
      return res.selectedSeats
      // return true
    }
    throw new AppError('已被占座，稍后重试')
  })
}

export const updateSelectedSeats = ({
  commit
}, res) => {
  commit(types.UPDATE_SELECTED_SEATS, res)
}



// WEBPACK FOOTER //
// ./src/store/seat/actions.js